import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import { addAresField, getAresValues, removeAresField } from '../../../actions/form';
import ContactsModal from './ContactsModal';
import NewContactModal from './NewContactModal';
import { is } from 'ramda';
import DeleteAresContactsModal from './DeleteAresContactsModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {  Button, InputAdornment  } from "@mui/material";
import TextField from "../../../../TextField";
import { toggleModal } from '../../../../ModalTest/actions';

interface TextFieldInterface extends ControlInterface {
	multiline: boolean;
	actions: any;
	formInstanceId: string;
	contactsModal: any;
	newContactModal: any;
	deleteAresContactsModal: any;
}

class AresField extends React.PureComponent<TextFieldInterface> {
	onFieldChange = (event: React.ChangeEvent, index: number, key: string) => {
		event.preventDefault();
		const { onChange, name, dirty } = this.props;
		const { value } = event.target as HTMLInputElement;
		onChange([name, 'value', index, key], value, dirty);
	};

	handleAddField = () => {
		const { actions, name, formInstanceId } = this.props;
		actions.addAresField(formInstanceId, name);
	};

	handleRemoveField = (index: number) => {
		const { actions, name, formInstanceId } = this.props;
		actions.removeAresField(formInstanceId, name, index);
	};

	handleValidateField = (index: number, ico: number | string) => {
		const { actions, formInstanceId, name, control: {params} } = this.props;
		actions.getAresValues(formInstanceId, name, index, ico, params?.country === "SK" ? "SK" : "CZ");
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	handleContacts = (index: number) => {
		const { actions, formInstanceId, name } = this.props;
		actions.toggleModal(true, name, { index }, formInstanceId);
	};

	render() {
		const {
			autoFocus,
			disabled,
			value,
			control: {
				params: { forceEditable, country },
			},
			name,
			contactsModal,
			newContactModal,
			deleteAresContactsModal,
			formInstanceId,
			className,
			mandatory,
			placeholder,
			error
		} = this.props;

		let finalValue = value;

		if (is(String, value)) {
			try {
				finalValue = JSON.parse(value);
			} catch (e) {
				finalValue = [
					{
						aresError: false,
						companyName: '',
						contacts: [],
						dic: '',
						ico: '',
						street: '',
						town: '',
						zip: '',
					},
				];
			}
		} else if (value === null) {
			finalValue = [
				{
					aresError: false,
					companyName: '',
					contacts: [],
					dic: '',
					ico: '',
					street: '',
					town: '',
					zip: '',
				},
			];
		}

		return (
			<React.Fragment>
				{finalValue.map((it: any, index: number) => {
					// Define warning message --> Simple validation as whole ARES is made quite fast and simple
					const important = !it?.ico || !Number(it?.ico) || it?.ico?.length !== 8;
					// Define helper Text
					let helperText: string = '';
					if (it?.aresError) helperText = window.Alfresco.messages.global['edocat.forms.invalidIco'];
					else if (!it?.ico) helperText = window.Alfresco.messages.global['edocat.forms.missingIco'];
					else if (!Number(it?.ico) || it?.ico?.length !== 8)
						helperText = window.Alfresco.messages.global['Alfresco.forms.validation.invalid.message'];
					return (
						<div className="aresCompanySet--Edit" key={index}>
							{Object.keys(it).map((item: string, innerIndex: number) =>
								item !== 'contacts' && item !== 'aresError' ? (
									<div className={`form-row row-${name}`} key={`${index}${innerIndex}`}>
										<TextField
											autoFocus={autoFocus}
											className={
												className +
												(item === 'ico' && (important || it?.aresError)
													? typeof error === "string" ? " errorAres validateAresFiled" : ' important validateAresFiled'
													: ' validateAresFiled')
											}
											type={item === 'ico' ? 'tel' : 'text'}
											helperText={item === 'ico' && helperText}
											important={item === 'ico' && (important || it?.aresError) ? helperText : ''}
											disabled={forceEditable ? false : disabled}
											label={window.Alfresco.messages.global[`edocat.forms.${item}`]}
											mandatory={mandatory}
											name={name}
											onBlur={this.onBlur}
											onChange={(event: React.ChangeEvent) => this.onFieldChange(event, index, item)}
											value={it?.[item]}
											placeholder={placeholder}
											endAdornment={
												item === 'ico' && (
													<InputAdornment position="end">
														<Button
															color="primary"
															variant="contained"
															size="small"
															disabled={important}
															onClick={() => this.handleValidateField(index, it?.ico)}
															disableElevation
														>
															{window.Alfresco.util.message("edocat.forms.valide-ares", null, country && country === "SK" ? "RÚZ" : "ARES")}
														</Button>
													</InputAdornment>
												)
											}
										/>
									</div>
								) : null
							)}
							<div className={`form-row row-${name}`}>
								<label>{window.Alfresco.messages.global['edocat.forms.contacts']}:</label>
								<span>
									<Button disableElevation variant="outlined" onClick={() => this.handleContacts(index)} size="small">
										{window.Alfresco.messages.global['edocat.forms.show-table']}
									</Button>
								</span>
							</div>
							<div className={`form-row row-${name}`}>
								{finalValue.length > 1 && (
									<Button
										color="primary"
										variant="outlined"
										disabled={value?.length === 1}
										onClick={() => this.handleRemoveField(index)}
										disableElevation
									>
										{window.Alfresco.messages.global['edocat.forms.deleteCompany']}
									</Button>
								)}
								{finalValue.length - 1 === index && (
									<Button disableElevation variant="contained" color="primary" onClick={this.handleAddField}>
										{window.Alfresco.messages.global['edocat.forms.addCompany']}
									</Button>
								)}
							</div>
						</div>
					);
				})}
				{contactsModal.isOpen && (
					<ContactsModal {...{ index: contactsModal?.items?.index, name, value, contactsModal, formInstanceId }} />
				)}
				{newContactModal.isOpen && contactsModal.isOpen && (
					<NewContactModal {...{ index: contactsModal?.items?.index, name, newContactModal, formInstanceId }} />
				)}
				{deleteAresContactsModal.isOpen && contactsModal.isOpen && (
					<DeleteAresContactsModal {...{ items: DeleteAresContactsModal.items }}/>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const contactsModal = state?.[props.formInstanceId]?.formModal?.[props.name] || {};
	const newContactModal = state?.[props.formInstanceId]?.formModal?.newContactModal || {};
	const deleteAresContactsModal = state?.[props.formInstanceId]?.formModal?.deleteAresContactsModal || {};
	return {
		contactsModal,
		newContactModal,
		deleteAresContactsModal
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ addAresField, getAresValues, toggleModal, removeAresField }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AresField);
